import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useReactToPrint } from "react-to-print";
import MobileNav from "../../components/mobileNav/MobileNav";
import "./cancelledRequests.css";
import PrintingHeader from "../../components/printingHeader/PrintingHeader";
import printIcon from "../../assets/print-icon.svg";
import ReactPaginate from "react-paginate";

const CancelledRequests = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(0); // Add current page state

  const url = `https://api.generalhome.sa/api/maintenance/GetCancelRequests`;
  const maxLength = 10;
  const maxLengthCity = 6;

  // Options for items per page dropdown
  const itemsPerPageOptions = [25, 50, 100, 300, 400, totalItems];

  const getAllAppointments = async (
    currentPage = 1,
    pageSize = itemsPerPage
  ) => {
    try {
      setLoading(true);
      const maintenanceAreaIdsString =
        localStorage.getItem("MaintenanceAreaIds");
      const maintenanceAreaIds = maintenanceAreaIdsString
        .split(",")
        .map(Number);

      const res = await axios.post(url, {
        maintenanceAreaIds,
        Page: currentPage,
        PageSize: pageSize,
      });

      const totalItems = res.data.TotalItems;
      const totalPages = res.data.TotalPages || 1;
      const totalNumberOfPages = totalPages || Math.ceil(totalItems / pageSize);

      setPageCount(totalNumberOfPages);
      setItems(res.data.Items);
      setTotalItems(res.data.TotalItems);

      // Update current page state (convert to zero-based for ReactPaginate)
      setCurrentPage(currentPage - 1);
    } catch (err) {
      console.error(err);
      setError(err.message);
      setItems([]);
      setTotalItems(0);
      setPageCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = async (data) => {
    const selectedPage = data.selected; // This is zero-based (0, 1, 2...)
    const currentPage = selectedPage + 1; // Convert to one-based for API
    await getAllAppointments(currentPage, itemsPerPage);
  };

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage = parseInt(event.target.value);
    setItemsPerPage(newItemsPerPage);
    // Reset to first page when changing items per page
    setCurrentPage(0); // Reset to first page
    getAllAppointments(1, newItemsPerPage);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Report",
    onAfterPrint: () => console.log("print success"),
  });

  const formatACTypes = (maintenanceDetails) => {
    if (!maintenanceDetails || maintenanceDetails.length === 0) return "--";
    return maintenanceDetails.map((detail) => detail.ACTypeName).join("، ");
  };

  useEffect(() => {
    getAllAppointments(1, itemsPerPage);
  }, []);

  return (
    <>
      <MobileNav />
      <section className="cancelledRequests mt-0">
        <Helmet>
          <meta charSet="utf-8" />
          <title>الطلبات الملغيه</title>
          <link
            rel="canonical"
            href="https://generalhome.sa/dashboard/inProgress"
          />
        </Helmet>
        {loading ? (
          <div className="spinner-container">
            <ClipLoader
              className="loader"
              loading={loading}
              size={100}
              aria-label="Loading Spinner"
              data-testid="loader"
              color="#00b1ff"
            />
          </div>
        ) : (
          <div className="newAppointment-container" ref={componentRef}>
            <PrintingHeader title="الطلبات الملغيه" count={totalItems} />
            <div className="d-flex justify-content-between info">
              <div className="info-header">
                <h2>الطلبات الملغيه</h2>
                <h3>{totalItems}</h3>
              </div>
              <div className="print-icon-holder">
                <img
                  src={printIcon}
                  alt="printIcon"
                  className="print-icon"
                  onClick={handlePrint}
                />
              </div>
            </div>

            {/* Items per page selector and pagination */}
            <div className="paginateComponent">
              <div className="items-per-page-selector">
                <select
                  id="itemsPerPage"
                  className="form-select form-select-sm"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  style={{
                    width: "80px",
                    display: "inline-block",
                    margin: "0 10px",
                  }}
                >
                  {itemsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              {pageCount > 0 && (
                <ReactPaginate
                  forcePage={currentPage} // Add this prop to force active page
                  previousLabel={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.94 4L6 4.94L9.05333 8L6 11.06L6.94 12L10.94 8L6.94 4Z"
                        fill="black"
                      />
                    </svg>
                  }
                  nextLabel={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.06 12L11 11.06L7.94667 8L11 4.94L10.06 4L6.06 8L10.06 12Z"
                        fill="black"
                        fillOpacity="0.3"
                      />
                    </svg>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-end"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              )}
            </div>

            <div className="table-responsive-sm overflow-auto">
              <table className="table table-striped table-responsive">
                <thead>
                  <tr>
                    <th scope="row">إسم العميل</th>
                    <th scope="row">رقم الهاتف</th>
                    <th scope="row">المدينه</th>
                    <th scope="row">نوع المكيف</th>
                    <th scope="row">تاريخ الصيانه</th>
                    <th scope="row">الفني المسؤول</th>
                    <th scope="row" className="text-center">
                      التحكم
                    </th>
                  </tr>
                </thead>
                {items?.length > 0 ? (
                  <tbody>
                    {items.map((appointment) => (
                      <tr key={appointment.RequestId}>
                        <td
                          style={{
                            position: "relative",
                            padding: 0,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                          }}
                        >
                          <div
                            style={
                              appointment.MaintenanceTypeId === 2
                                ? {
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    borderRight: "4px solid #007bff",
                                    padding: "8px",
                                    display: "flex",
                                  }
                                : {
                                    padding: "8px",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                  }
                            }
                          >
                            {appointment.CustomerName &&
                            appointment.CustomerName.length > maxLength
                              ? `${appointment.CustomerName.substring(
                                  0,
                                  maxLength
                                )}...`
                              : appointment.CustomerName}
                          </div>
                        </td>
                        <td>
                          <a
                            href={`https://api.whatsapp.com/send?phone=+966${appointment.PhoneNumber.replace(
                              /[^\d+]/g,
                              ""
                            )}&text=Hello%2C%20I'm%20interested%20in%20your%20product`}
                            target="__blank"
                            rel="noopener noreferrer"
                          >
                            {appointment.PhoneNumber}
                          </a>
                        </td>
                        <td>
                          {appointment.City &&
                          appointment.City.length > maxLengthCity
                            ? `${appointment.City.substring(
                                0,
                                maxLengthCity
                              )}...`
                            : appointment.City}
                        </td>
                        <td>
                          {formatACTypes(appointment.MaintenanceRequestDetails)
                            ?.length > maxLength
                            ? `${formatACTypes(
                                appointment.MaintenanceRequestDetails
                              ).substring(0, maxLength)}...`
                            : formatACTypes(
                                appointment.MaintenanceRequestDetails
                              )}
                        </td>
                        <td>{appointment.MaintenanceStartDate}</td>
                        <td>{appointment.TechnicianName}</td>
                        <td className="text-center btn-holder">
                          <Link
                            to={`/dashboard/inProgress/${appointment.RequestId}`}
                          >
                            <button>تفاصيل</button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr className="no-data-message">
                      <td colSpan="7">لا توجد بيانات لعرضها حاليا :(</td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default CancelledRequests;
